export default __webpack_public_path__ + "static/media/piggy-bank.a937c939.png";